import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
// import Snowfall from 'react-snowfall';

import 'modern-normalize/modern-normalize.css';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';
import theme from './utils/theme';
import App from './App';

import './stylesheet/fonts.css';
import './stylesheet/variables.css';
import './stylesheet/index.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        {/* снег для зимнего настроения */}
        {/* <Snowfall color="#9fabce" style={{ zIndex: 99999 }} /> */}
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
